<template>
    <flex-element :element-type="elementType" tag="aside">
        <nav class="f-pt-1 f-pb-1 f-text-left f-text-gray-600 f-text-0.875">
            <ul class="flex-breadcrumbs f-pl-2 f-pr-2 f-mb-0">
                <li class="flex-crumb f-inline-block  f-pr-1">
                    Sample
                </li>

                <li class="flex-crumb-arrow f-inline-block f-pr-1 f-text-0.625">
                    <a-icon icon="chevron-double-right" />
                </li>

                <li class="flex-crumb f-inline-block f-pr-1">
                    Breadcrumbs
                </li>
            </ul>
        </nav>
    </flex-element>
</template>

<script>
import baseOrganism from '@/mixins/base-organism/base-organism-smart';

export default {
    mixins: [baseOrganism],

    props: {
        displayName: {
            type: String,
            default: 'Sitecore Breadcrumbs',
        },

        renderingId: {
            type: String,
            default: '{43C21337-5DB9-4005-9210-A79B7B579659}',
        },
    },

    data() {
        return {
            cssDisplay: 'block',
        };
    },

    computed: {
        getBreadcrumbs() {
            // potentially breadcrumbs should just be a specific server side rendering?
            const path = window.location.pathname.split('/').filter(val => val !== '');
            const parts = [{ text: 'Home', link: '/' }];

            for (let i = 0; i < path.length; i++) {
                const text = path[i];
                const link = `/${ path.slice(0, i + 1).join('/') }`;
                parts.push({ text, link });
            }

            return parts;
        },
    },
};
</script>

<style lang="scss">
.flex-breadcrumbs {
    list-style-type: none;
}

.flex-crumb-arrow:last-child {
    display: none;
}

.flex-crumb {
    text-transform: capitalize;
}
</style>
